// Enumeration for button types
export enum ButtonType {
  primary = 'primary',
  secondary = 'secondary',
  activeStep = 'active-step',
  inactiveStep = 'inactive-step',
  cart = 'cart'
}
